import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { format } from '@shared/utilities/formatEmail';

const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private _http: HttpClient) {}

  purchaseParts(NoOfParts, username, propertyId): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/purchase-parts/${propertyId}`,
      { NoOfParts }
    );
  }

  orderDetails(NoOfParts, username, propertyId): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/order-details/${propertyId}`,
      { NoOfParts }
    );
  }
}
